import { useRef } from 'react'

// Owns the hidden layout-export file input and hands the chosen file to onImport. `children` is a
// render function receiving `open`, so each surface supplies its own trigger (button, link) while
// sharing one input. Imports nothing from the portal (auth/Apollo/Redux), so the public planner
// bundle can use it.
export default function ImportLayoutPicker ({ onImport, children }) {
  const inputRef = useRef(null)
  return (
    <>
      {children(() => inputRef.current?.click())}
      <input
        ref={inputRef}
        type='file'
        accept='.json,application/json'
        hidden
        aria-label='Layout file to import'
        onChange={event => {
          const file = event.target.files?.[0]
          // Reset so choosing the same file again (e.g. after fixing it) still fires a change.
          event.target.value = ''
          if (file) onImport(file)
        }}
      />
    </>
  )
}
